export default {
  diecutId: 'components.views.my-diecuts-view.column-diecut-id',
  format: 'components.views.my-diecuts-view.column-format',
  noOfUnits: 'components.views.my-diecuts-view.column-noOfUnits',
  dateCreated: 'components.views.my-diecuts-view.column-dateCreated',
  header: 'components.views.my-diecuts-view.header'
}
